import { Injectable, OnDestroy } from '@angular/core';

import { FsStore } from '@firestitch/store';

import { Subject, Observable, interval, concat, merge, of } from 'rxjs';
import { takeUntil, takeWhile, switchMap, startWith, catchError } from 'rxjs/operators';

import { AccountData } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationService implements OnDestroy {

  public notification$: Observable<any>;

  private _reloadNotification$ = new Subject();
  private _intervalSeconds = 60;
  private _destroy$ = new Subject<void>();
  private _account;

  constructor(
    private _accountData: AccountData,
    private _store: FsStore,
  ) {
    this.notification$ =
      merge(
        interval(this._intervalSeconds * 1000),
        this._reloadNotification$,
      )
        .pipe(
          startWith(0),
          takeWhile(() => {
            return !!this._account;
          }),
          switchMap(() => {
            return this._accountData.notificationsUnread()
              .pipe(
                catchError(() => {
                  return of();
                }),
              );
          }),
        );

    this._store.observe('account')
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe((store) => {
        this._account = store.value;
      });
  }

  public reload(): void {
    this._accountData.notificationsUnread()
      .subscribe((unread) => {
        this._reloadNotification$.next(unread);
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

}
